import {
  compose,
  setDisplayName,
  setPropTypes,
  withProps,
  withStateHandlers,
} from 'recompose'
import PropTypes from 'prop-types'
import once from 'lodash/once'
import noop from 'lodash/noop'
const withOnceFn = name =>
  compose(
    setDisplayName('withOnceFn'),
    setPropTypes({
      hasData: PropTypes.bool,
      fn: PropTypes.func.isRequired,
    }),
    withStateHandlers(({ hasData }) => ({ initialized: hasData || false }), {
      setInitialized: () => ({ initialized: true }),
    }),
    withProps(({ fn, hasData }) => ({ [name]: hasData ? noop : once(fn) }))
  )

export default withOnceFn
